export interface Category {
  name: string;
  nameDe: string;
  url: string;
  icon: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    nameDe: "Schuhe",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20fashion%20sneakers%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20elegant%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%20studio%20shot%20with%20gentle%20shadows%2C%20minimalist%20composition&width=400&height=400&seq=cat-shoes-001&orientation=squarish",
  },
  {
    name: "Hoodies/Sweaters",
    nameDe: "Hoodies & Pullover",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20oversized%20hoodie%20on%20clean%20beige%20background%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20warm%20terracotta%20tone%2C%20clean%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-hoodies-002&orientation=squarish",
  },
  {
    name: "T-Shirts",
    nameDe: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20cotton%20t-shirt%20on%20clean%20sand%20background%2C%20soft%20natural%20lighting%2C%20contemporary%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-tshirts-003&orientation=squarish",
  },
  {
    name: "Jackets",
    nameDe: "Jacken",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20bomber%20jacket%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20coral%20accents%2C%20clean%20minimal%20composition%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-jackets-004&orientation=squarish",
  },
  {
    name: "Pants/Shorts",
    nameDe: "Hosen & Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20cargo%20pants%20on%20clean%20beige%20background%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-pants-005&orientation=squarish",
  },
  {
    name: "Headwear",
    nameDe: "Kopfbedeckungen",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-user-5-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20bucket%20hat%20on%20clean%20sand%20background%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20warm%20terracotta%20tones%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-headwear-006&orientation=squarish",
  },
  {
    name: "Sets",
    nameDe: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20matching%20clothing%20set%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20warm%20coral%20and%20beige%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-sets-007&orientation=squarish",
  },
  {
    name: "Underwear/Underpants",
    nameDe: "Unterwäsche",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20cotton%20underwear%20on%20clean%20beige%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-underwear-008&orientation=squarish",
  },
  {
    name: "Jersey",
    nameDe: "Trikots",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20football%20jersey%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20sports%20photography%2C%20warm%20coral%20accents%2C%20clean%20minimal%20composition%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-jersey-009&orientation=squarish",
  },
  {
    name: "Accessories",
    nameDe: "Accessoires",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20sunglasses%20and%20watch%20on%20clean%20sand%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-accessories-010&orientation=squarish",
  },
  {
    name: "Bags",
    nameDe: "Taschen",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20canvas%20tote%20bag%20on%20clean%20beige%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20terracotta%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-bags-011&orientation=squarish",
  },
  {
    name: "Belts",
    nameDe: "Gürtel",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-loop-left-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20leather%20belt%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-belts-012&orientation=squarish",
  },
  {
    name: "Perfumes",
    nameDe: "Parfums",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20glass%20perfume%20bottle%20on%20clean%20sand%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20coral%20glow%2C%20clean%20minimal%20composition%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-perfumes-013&orientation=squarish",
  },
  {
    name: "Other Stuff",
    nameDe: "Sonstiges",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    imageUrl: "https://readdy.ai/api/search-image?query=minimal%20various%20fashion%20accessories%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20aesthetic%2C%20high%20detail%20studio%20shot&width=400&height=400&seq=cat-other-014&orientation=squarish",
  },
];

export const articleLinks = [
  { title: "OOPBuy Spreadsheet: Der komplette Guide für Einsteiger", slug: "oopbuy-spreadsheet-guide", description: "Alles was Sie über OOPBuy Spreadsheet wissen müssen – von der ersten Nutzung bis zu Profi-Tipps." },
  { title: "OOPBuy Spreadsheet Anleitung: Schritt-für-Schritt zur perfekten Produktsuche", slug: "oopbuy-spreadsheet-anleitung", description: "Detaillierte Schritt-für-Schritt Anleitung zur Nutzung des OOPBuy Spreadsheet." },
  { title: "OOPBuy Spreadsheet Sicherheit: Was Nutzer unbedingt wissen müssen", slug: "oopbuy-spreadsheet-sicherheit", description: "Alles zur Sicherheit – Datenschutz, Produktauthentizität und mehr." },
  { title: "OOPBuy Spreadsheet Vergleich: Die beste Suchmethode im Test", slug: "oopbuy-spreadsheet-vergleich", description: "Detaillierter Vergleich zwischen OOPBuy Spreadsheet und alternativen Suchmethoden." },
  { title: "OOPBuy Spreadsheet Erfahrungen 2026: Echte Nutzer berichten", slug: "oopbuy-spreadsheet-erfahrung", description: "Authentische Erfahrungsberichte aus Deutschland, Österreich und der Schweiz." },
  { title: "OOPBuy Spreadsheet Kosten: Preise, Gebühren und Spartipps 2026", slug: "oopbuy-spreadsheet-kosten", description: "Transparente Übersicht aller Kosten inklusive Spartipps." },
  { title: "Beste OOPBuy Spreadsheet Produkte: Top 20 Empfehlungen 2026", slug: "oopbuy-spreadsheet-produkte", description: "Unsere Top 20 Produktempfehlungen – sorgfältig ausgewählt und geprüft." },
  { title: "OOPBuy Spreadsheet Profi-Tipps: 25 Geheimnisse für Power-User", slug: "oopbuy-spreadsheet-tipps", description: "25 exklusive Profi-Tipps für maximale Effizienz." },
  { title: "OOPBuy Spreadsheet für Anfänger: Der einfache Einstieg", slug: "oopbuy-spreadsheet-anfaenger", description: "Der ultimative Anfänger-Guide – verständlich erklärt ohne Fachbegriffe." },
  { title: "OOPBuy Spreadsheet Update 2026: Alle neuen Funktionen", slug: "oopbuy-spreadsheet-update", description: "Alle wichtigen Updates und neuen Funktionen auf einen Blick." },
];